/** 繁体 */
export default {
    age: "年齡",
    submit: "提交",
    netWorkError: "網絡鏈接異常請重新鏈接",
    example: {
        name: "張三"
    }
}